/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { useState, useCallback } from 'react';
import '../_chunks/dep-2acfafca.js';

function useDomRefCallback() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    refCurrent = _useState2[0],
    setRefCurrent = _useState2[1];
  useCallback(function (dom) {
    if (dom) setRefCurrent(dom);
  }, []);
  return [refCurrent, setRefCurrent];
}

export { useDomRefCallback as default };
//# sourceMappingURL=useDomRefCallback.js.map
